/**
 * 工具类
 * Liyc
 * 2022-03-17
 */
//统一暴露
//import utils from './utils/utils'
export default {
	dateformat:(value)=>{
		var date = new Date(value);
		return date.getFullYear()+"-"+ (date.getMonth()+parseInt(1))+"-"+date.getDate()+" "+date.getHours()+":"+date.getMinutes()+":"+date.getSeconds();
	},
	fileSize:(size)=>{
		size = parseFloat(size);
		if(size<1024){
			return size.toFixed(2)+"KB";
		}else{
			return  parseFloat(size/1024).toFixed(2)+"MB";
		}
	},
	fileNum:(size)=>{
		size = parseFloat(size);
		if(size<1000){
			return parseInt(size);
		}else{
			return parseFloat(size/1000).toFixed(2)+"K";
		}
	},
	getChilrenTree(_list,_chilren){
			
		if(_chilren.length==0){
			_list = null;
			return _list;
		}else{
			_chilren.forEach(item=>{
				var _list2 = [];
				var _children2 = item.children;
				
				var newItem = {
					value:  parseInt(item.classifyId),
					label: item.classifyName,
					is_check:false
				}
				if(_children2.length>0){
					newItem.children = this.getChilrenTree(_list2,_children2);
				}
				_list.push(newItem);
				
			})
			
		}
		return _list;
	},
}

//分别暴露
//import {dateformat} from './utils/utils'
// const dateformat = (value)=>{
// 	var date = new Date(value);
// 	return date.getFullYear()+"-"+ (date.getMonth()+parseInt(1))+"-"+date.getDate()+" "+date.getHours()+":"+date.getMinutes()+":"+date.getSeconds();
// }
// export{
// 	dateformat
// }